import { useEffect, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { loaderActions } from '../../../../_actions/loader.actions';
import { getAllData, postDownloadVoucher, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../../components/commonClass/Session';
import { decryptUrlDatapattern, encryptUrlDatapattern } from '../../../../components/commonClass/EncFunc';
import { fetchIp, trackPurchase } from '../../../../components/commonClass/CommonFunctions';
import StartRating from '../../../../components/StartRating';
import HotelCancellation from './HotelCancellation';
import OnHoldCancellation from './OnHoldCancellation';
import HotelCancellationMessage from '../../../../customControl/HotelCancellationMessage';

export function numberWithCommas(x: any) {
    return x?.toString()?.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
}


const HotelBookingConfirmation = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [hotelBookingData, setHotelBookingData] = useState<any>({
        hotelDetails: null,
        bookingDetails: null,
        Messages: null
    });
    const [searchParams, setSearchParams] = useSearchParams();
    const APIBadMessage = 'Something went wrong, Please try again!';
    const [showTryAgain, setShowTryAgain] = useState(false)

    const [isCancelModel, setIsCancelModel] = useState(false);
    const [cancelModelData, setCancelModelData] = useState({});
    const [showCancelMessageModel, setShowCancelMessageModel] = useState(false);
    const [cancellationMessage, setCancellationMessage] = useState("");

    const [holdCancelModal, setHoldCancelModal] = useState(false);

    const getCancellationDateformat = (date:any) => {
        const lastDate = new Date(date);
        const dt = lastDate?.getDate()?.toString()?.length > 1 ? lastDate?.getDate() : `0${lastDate?.getDate()}`;
        const month = (lastDate?.getMonth() + 1)?.toString()?.length > 1 ? lastDate?.getMonth() + 1 : `0${lastDate?.getMonth() + 1}`;
        const year = lastDate?.getFullYear()?.toString()?.length > 1 ? lastDate?.getFullYear() : `0${lastDate?.getFullYear()}`;
        const hour = lastDate?.getHours()?.toString()?.length > 1 ? lastDate?.getHours() : `0${lastDate?.getHours()}`;
        const minute = lastDate?.getMinutes()?.toString()?.length > 1 ? lastDate?.getMinutes() : `0${lastDate?.getMinutes()}`;
        const seconds = lastDate?.getSeconds()?.toString()?.length > 1 ? lastDate?.getSeconds() : `0${lastDate?.getSeconds()}`;
        return date ? `${dt}-${month}-${year}, ${hour}:${minute}:${seconds}` : "";
    }

    const diffDays = (d1:any, d2:any) => {
        if (d1 && d2) {
            const date1:any = new Date(d1);
            const date2:any = new Date(d2);

            const difference = Math.abs(date2 - date1);
            const totalDays = Math.ceil(difference / (1000 * 60 * 60 * 24));
            return totalDays;
        }
        else {
            return 0;
        }
    }

    useEffect(() => {
        if (localStorage.getItem('last') !== null && localStorage.getItem('last') === "true") {
            window.history.forward()
        }
    }, [])

    const gethotelbookingdetails = async (data:any) => {
        let hotelpaymentresponse:any, bookingcodebybookingid:any, hotelbookingdetails:any = { status: true }

        hotelpaymentresponse = await postUsersData('/customerui/v1/gethotelpaymentresponse', {
            BookingId: data?.BookingId,
            ResponseType: data?.ResponseType,
            PaymentId: data?.PaymentId,
            UserId: data?.UserId
        })
        if (hotelpaymentresponse?.status) {
            setHotelBookingData((prev:any) => ({ ...prev, Messages: hotelpaymentresponse?.data }));

            bookingcodebybookingid = await getAllData(`/customerui/v1/gethoteldetailsbybookingid?bookingId=${data?.BookingId}`)
            if (bookingcodebybookingid?.status) {
                setHotelBookingData((prev:any) => ({ ...prev, bookingDetails: bookingcodebybookingid?.data }));

                if (hotelpaymentresponse?.data?.[0]?.ResponseType === 1 || hotelpaymentresponse?.data?.[0]?.ResponseType === 3) {
                    hotelbookingdetails = await postUsersData('/customerui/v1/gethotelbookingdetails', {
                        EndUserIp: data?.EndUserIp,
                        BookingId: data?.hotelBookingId
                    })
                    if (hotelbookingdetails?.status) {
                        setHotelBookingData((prev:any) => ({ ...prev, hotelDetails: hotelbookingdetails?.data }));
                    }
                }
            }
        }

        let apiCollections = [hotelpaymentresponse, bookingcodebybookingid, hotelbookingdetails];
        let falseStatus = apiCollections?.find((ele) => !ele?.status)
        if (falseStatus) {
            dispatch({ type: 'ALERTING', message: falseStatus?.message || APIBadMessage });
            dispatch(loaderActions.end());
        }

    }

    useEffect(() => {
        async function fetchData() {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                if (location?.state !== null) {
                    let user:any = GetLocalStorage();
                    let userip = await fetchIp();
                    if (userip?.status) {
                        let data = {
                            EndUserIp: userip?.data,
                            hotelBookingId: location?.state?.hotelBookingId,
                            BookingId: decryptUrlDatapattern(location?.state?.BookingId),
                            ResponseType: location?.state?.ResponseType,
                            PaymentId: location?.state?.PaymentId,
                            UserId: user?.userMasterID
                        }
                        dispatch(loaderActions.start());
                        if (sessionStorage.getItem('isCancel') === "true" && sessionStorage.getItem('bid') === `${location?.state?.BookingId}`) {
                            sessionStorage.removeItem('isCancel')
                            navigate('/hotels');
                        }
                        else {
                            await Promise.all([
                                gethotelbookingdetails(data),
                            ])
                        }
                        localStorage.setItem("last", "true")
                        localStorage.setItem("isOpenDup", "false")
                        dispatch(loaderActions.end());
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', redirectTo: '/' });
                    }
                }
                else {
                    dispatch({ type: 'ALERTING', message: 'Something went wrong, Please try again!', redirectTo: '/' });
                }
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
        fetchData();
    }, [])

    const dateFormat = (date:any) => {
        let d = new Date(date);
        let day = d?.toLocaleString("en-US", { day: '2-digit' });
        let month = d?.toLocaleString("en-US", { month: 'short' });
        let year = d?.toLocaleString("en-US", { year: 'numeric' });
        return date ? `${day} ${month} ${year}` : null;
    }

    const hotelDateFormat = (selectDate:any, type = 'date') => {
        const d = new Date(selectDate);
        const weekday = d?.toLocaleString("en-US", { weekday: 'long' });
        const day = d?.toLocaleString("en-US", { day: 'numeric' });
        const month = d?.toLocaleString("en-US", { month: 'short' });
        const year = d?.toLocaleString("en-US", { year: 'numeric' });
        let hours = d?.getHours();
        const minute = d?.getMinutes()?.toString()?.padStart(2, '0')
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 === 0 ? 12 : hours % 12;
        return selectDate ? type === 'date' ? `${weekday},${day} ${month} ${year}` : `${hours?.toString()?.padStart(2, '0')}:${minute} ${ampm}` : null;
    }

    const handleBack = (e:any, responseType:any) => {
        e.preventDefault();
        if (responseType === 1) {
            navigate('/profile/my-bookings', { state: { tabname: 'Upcoming', moduleType: 5 } });
        }
        else if (responseType === 2) {
            navigate('/profile/my-bookings', { state: { tabname: 'onhold', moduleType: 5 } });
        }
        else {
            setShowTryAgain(true);
        }
    }

    const closeModal = () => {
        setShowTryAgain(false);
    }


    const roomWithNight = useMemo(() => {
        if (hotelBookingData?.Messages?.[0]?.ResponseType === 1) {
            if (sessionStorage?.getItem("isHotelPurchase") === 'false' && hotelBookingData?.bookingDetails?.[0]?.finalValue) {
                trackPurchase(hotelBookingData?.bookingDetails?.[0]?.finalValue)
            }
            return {
                room: hotelBookingData?.hotelDetails?.getBookingDetailResult?.rooms?.length,
                night: diffDays(hotelBookingData?.hotelDetails?.getBookingDetailResult?.checkInDate, hotelBookingData?.hotelDetails?.getBookingDetailResult?.checkOutDate)
            }
        }
        else {
            return {
                room: hotelBookingData?.bookingDetails?.[0]?.roomDetailsModel?.length,
                night: diffDays(hotelBookingData?.bookingDetails?.[0]?.checkInDate, hotelBookingData?.bookingDetails?.[0]?.checkoutDate)
            }
        }
    }, [hotelBookingData])

    const RetryPayment = (name:any) => {
        const isRetry = encryptUrlDatapattern("true");
        localStorage.setItem("isRetry", isRetry);
        const newSearchParams = new URLSearchParams(searchParams);
        navigate({ pathname: `/hotel/` + name, search: newSearchParams.toString() }, { state: { ...location?.state, isRetryPayment: true } })
        setShowTryAgain(false);
    }

    const holdRetryPayment = () => {
        const isRetry = encryptUrlDatapattern("true");
        localStorage.setItem("isRetry", isRetry);
        navigate('/profile/my-bookings', { state: { tabname: 'onhold', moduleType: 5, isRetryPayment: true } });
        setShowTryAgain(false);
    }


    const closeCancelModal = () => {
        setIsCancelModel(false)

    };

    const handleCanelApply = async (hotelBookingData:any) => {

        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const etmBookingId = hotelBookingData?.bookingDetails?.[0]?.hotelBookingId
            const tboBookingId = hotelBookingData?.hotelDetails?.getBookingDetailResult?.bookingId
            dispatch(loaderActions?.start());

            const res = await getAllData(`/customerui/v1/gethotelcancellationchargesbyid?hotelBookingId=${etmBookingId}`);

            if (res?.status) {
                setCancelModelData({
                    ...res.data,
                    localBookingId: etmBookingId, TboBookingId: tboBookingId
                })
                setIsCancelModel(true)
                dispatch(loaderActions?.end());
            }
            else {
                dispatch({ type: 'ALERTING', message: res.message });
                dispatch(loaderActions?.end());
            }
        }
        else {
            dispatch(loaderActions?.end());
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
        }
    }

    const getStatusMessage = (status:any, payment:any) => {
        switch (status) {
            case 0: return payment === "failed" ? "" : "Booking Failed";
            case 1: return "Booking Confirmed";
            case 2: return "Booking Pending";
            case 3: return "Reservation Hold Confirmation";

            default: return "Booking Failed";
        }
    }

    const generatePDF = async (id:any) => {
        const postdata = {
            BookingId: id,
            TravelCategoryId: 5
        }
        const Response = await postDownloadVoucher('/customerui/v1/getvouchertemplatebytravelcategoryid', postdata, 5);
        if (!Response?.status) {
            dispatch({ type: 'ALERTING', message: Response.message });
        }
    };

    return (
        <div className='confirmBookingTemp' >

            <div className="buttonSec">
                <div className="container">
                    {
                        hotelBookingData?.Messages?.[0]?.ResponseType !== 3 ?
                            <div className="buttonDiv">
                                <button type='button' className='border-0 p-0' onClick={(e) => handleBack(e, hotelBookingData?.Messages?.[0]?.ResponseType)}><i className="fa-solid fa-arrow-left"></i></button>
                                {
                                    hotelBookingData?.Messages?.[0]?.ResponseType === 1 &&
                                    <div>
                                        <button className="button" onClick={() => generatePDF(hotelBookingData?.bookingDetails?.[0]?.hotelBookingId)} type='button'><i className="fa-solid fa-download"></i> Download </button>&nbsp;
                                        <button className="button" type='button' onClick={() => { handleCanelApply(hotelBookingData) }}>
                                            <i className="fa-solid fa-ticket"></i> Cancel
                                        </button>
                                    </div>
                                }
                            </div>
                            :
                            <div className="buttonDiv justify-content-end">
                                <button className="button" type='button' onClick={() => setHoldCancelModal(true)}>
                                    <i className="fa-solid fa-ticket"></i> Cancel
                                </button>
                            </div>
                    }
                </div>
            </div>

            <div className='hotel_booking_confirmation midSection'>
                <Modal
                    show={showTryAgain}
                    onHide={() => closeModal()}
                    size="sm"
                    // backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <center className="p-3">
                        <h5 className="my-3 fw-bold"> Booking Failed </h5>
                        <div className="my-3">
                            {location?.state?.ResponseType === 4 && location?.state?.payment === "failed" ?
                                <button
                                    type="button"
                                    className='btn proceedbookingBtn text-center'
                                    onClick={() => holdRetryPayment()}
                                >
                                    Try Again
                                </button>
                                :
                                <button
                                    type="button"
                                    className='btn proceedbookingBtn text-center'
                                    onClick={() => RetryPayment('review')}
                                >
                                    Try Again
                                </button>

                            }
                        </div>
                    </center>
                </Modal>

                <div className='container'>
                    {/* hotel label */}
                    <div className="p_confirm">
                        {
                            getStatusMessage(hotelBookingData?.Messages?.[0]?.ResponseType, location?.state?.payment)
                        }

                    </div>
                    <div className='bookingTempHead mt-2'>
                        <div className="row">
                            <div className="col-md-6 col-lg-9">
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <div className="headRight mb-2">
                                    <table style={{ width: '100%', textAlign: 'right' }}>
                                        <tbody>
                                            <tr>
                                                <td><strong>ETM Ref No :</strong></td>
                                                <td>{hotelBookingData?.bookingDetails?.[0]?.bookingNo}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Confirmation status with text */}
                        {/* Success */}
                        {
                            hotelBookingData?.Messages?.[0]?.ResponseType === 1 &&
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="status-success">
                                        <i className="fa-solid fa-check"></i>
                                        <p>{hotelBookingData?.Messages?.[0]?.TransMessage1} </p>
                                        <h3>{hotelBookingData?.Messages?.[0]?.TransMessage2}</h3>
                                    </div>
                                    <div className="success-alert-msg">
                                        <p>{hotelBookingData?.Messages?.[0]?.TransMessage3}</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* Success */}

                        {/* Failure */}
                        {
                            hotelBookingData?.Messages?.[0]?.ResponseType === 0 &&
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="status-failed">
                                        <i className="fa-solid fa-xmark"></i>
                                        <p>{hotelBookingData?.Messages?.[0]?.TransMessage1}</p>
                                        <h3>{hotelBookingData?.Messages?.[0]?.TransMessage3}</h3>
                                    </div>
                                    <div className="failed-alert-msg">
                                        <p>{hotelBookingData?.Messages?.[0]?.TransMessage4}</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* Failure */}

                        {/* In Progress */}
                        {
                            hotelBookingData?.Messages?.[0]?.ResponseType === 2 &&
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="status-inprogress">
                                        <i className="fa-solid fa-check"></i>
                                        <p>{hotelBookingData?.Messages?.[0]?.TransMessage1}</p>
                                        <h3>{hotelBookingData?.Messages?.[0]?.TransMessage3}</h3>
                                    </div>
                                    <div className="inprogress-alert-msg">
                                        <p>{hotelBookingData?.Messages?.[0]?.TransMessage4}</p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* In Progress */}

                        {/* On Hold */}
                        {
                            hotelBookingData?.Messages?.[0]?.ResponseType === 3 &&
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="status-success">
                                        <i className="fa-solid fa-check"></i>
                                        <p>{hotelBookingData?.Messages?.[0]?.TransMessage1?.replace("#Username", "")} </p>
                                        <h3>{hotelBookingData?.Messages?.[0]?.TransMessage2}</h3>
                                    </div>
                                    <div className="success-alert-msg">
                                        <p>
                                            Note- This is Non vouchered Booking & will get auto cancelled on ( {getCancellationDateformat(hotelBookingData?.hotelDetails?.getBookingDetailResult?.etmLastCancellationDate)} ) if not paid.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }
                        {/* On Hold */}

                        {/* Hotel Details */}
                        <div className="mb-4">

                            <div className="row">
                                <div className="col-sm-4 col-12">
                                    <h5> Hotel Details </h5>
                                </div>
                                <div className="col-sm-8 col-12 my-sm-0 my-2">
                                    <div className='d-sm-flex d-block justify-content-end align-items-center'>
                                        {
                                            hotelBookingData?.Messages?.[0]?.ResponseType === 1 &&
                                            <div className='sub-title fw-bold'> Booking Id : <span className='ms-3 title_value fw-500' style={{ float: 'inline-end' }}> {hotelBookingData?.hotelDetails?.getBookingDetailResult?.confirmationNo} </span> </div>
                                        }
                                        <div className='ms-sm-3 sub-title fw-bold'> Booking Date : <span className='ms-3 title_value fw-500' style={{ float: 'inline-end' }}> {dateFormat(hotelBookingData?.bookingDetails?.[0]?.bookingDate)} </span> </div>
                                    </div>
                                </div>
                            </div>
                            <div className="hotelDetail">
                                <div className="col-md-3 col-12">
                                    <img
                                        style={{ aspectRatio: 3 / 2, borderRadius: '4px' }}
                                        src={hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.image ? hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.image : ''}
                                        onError={(e:any) => e.target.src = require("../../../../assets/img/no-image.png")}
                                        loading="lazy"
                                        alt="hotel" />
                                </div>
                                <div className="col-md-9 col-12 ps-md-3 ps-0 mt-md-0 mt-2">
                                    <h4>
                                        {
                                            hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                hotelBookingData?.hotelDetails?.getBookingDetailResult?.hotelDetails?.[0]?.hotelName :
                                                hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.hotelName

                                        }
                                    </h4>
                                    <div className="rating mb-2">
                                        {
                                            hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                <StartRating value={hotelBookingData?.hotelDetails?.getBookingDetailResult?.hotelDetails?.[0]?.hotelRating || 0} count={5} /> :
                                                <StartRating value={hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.hotelRating || 0} count={5} />
                                        }
                                    </div>
                                    <p><i className="fa-solid fa-location-dot"></i>
                                        {
                                            hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                hotelBookingData?.hotelDetails?.getBookingDetailResult?.hotelDetails?.[0]?.address :
                                                hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.address
                                        }
                                    </p>
                                    {
                                        [1, 3]?.includes(hotelBookingData?.Messages?.[0]?.ResponseType) &&
                                        <p>Phone No: {hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.phoneNumber}</p>
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Booking Information */}
                        <div className="mb-3">
                            <div className="">
                                <h5> Booking Information </h5>
                            </div>

                            <div className="bookInfo mb-5">
                                <h6>{roomWithNight?.night} Night</h6>
                                <table style={{ width: '100%', background: '#f0f5fa' }}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span>Check In</span>
                                                <h5>
                                                    {
                                                        hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                            hotelDateFormat(hotelBookingData?.hotelDetails?.getBookingDetailResult?.checkInDate) :
                                                            hotelDateFormat(hotelBookingData?.bookingDetails?.[0]?.checkInDate)
                                                    }
                                                </h5>
                                                <p>
                                                    {
                                                        hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                            hotelBookingData?.hotelDetails?.getBookingDetailResult?.hotelDetails?.[0]?.checkInTime :
                                                            hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.checkInTime
                                                    }
                                                </p>
                                            </td>
                                            <td style={{ textAlign: 'center' }} ><i className="fa-solid fa-angles-right"></i></td>
                                            <td>
                                                <span>Check Out</span>
                                                <h5>
                                                    {
                                                        hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                            hotelDateFormat(hotelBookingData?.hotelDetails?.getBookingDetailResult?.checkOutDate) :
                                                            hotelDateFormat(hotelBookingData?.bookingDetails?.[0]?.checkoutDate)
                                                    }
                                                </h5>
                                                <p>
                                                    {
                                                        hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                                            hotelBookingData?.hotelDetails?.getBookingDetailResult?.hotelDetails?.[0]?.checkOutTime :
                                                            hotelBookingData?.bookingDetails?.[0]?.hotelDetails?.[0]?.checkOutTime
                                                    }
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {
                                hotelBookingData?.Messages?.[0]?.ResponseType === 1 ?
                                    hotelBookingData?.hotelDetails?.getBookingDetailResult?.rooms?.map((room:any, roomIndex:any) => {
                                        return (
                                            <div key={`${room?.roomId}${roomIndex}`}>

                                                {/* Room Information */}
                                                <div className="mb-3">
                                                    <h5>Room Information</h5>
                                                    <table className="bookingStatusTable roomInfo" style={{ wordBreak: 'break-all' }}>
                                                        <thead>
                                                            <tr>
                                                                <th>Number of Rooms</th>
                                                                <th>Rooms Type</th>
                                                                <th>Guests</th>
                                                                <th>Rate Plan</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <p><strong>1 Room</strong></p>
                                                                </td>
                                                                <td>
                                                                    <p><strong>{room?.roomTypeName}</strong></p>
                                                                </td>
                                                                <td>
                                                                    <p><strong>{room?.adultCount > 1 ? 'Adults' : 'Adult'} - {room?.adultCount}, {room?.childCount > 1 ? 'Children' : 'Child'} - {room?.childCount}</strong></p>
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Guest Information */}
                                                <div className="mb-3">
                                                    <h5>Guest Information</h5>
                                                    <table className="bookingStatusTable" style={{ wordBreak: 'break-all' }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '34%' }}>Name</th>
                                                                <th style={{ width: '33%' }}>Email</th>
                                                                <th style={{ width: '33%' }}>Phone</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                room?.hotelPassenger?.filter((fin:any) => fin?.leadPassenger === true)?.map((pass:any, passIndex:any) => {
                                                                    return (
                                                                        <tr key={`${pass?.paxId}${passIndex}`} >
                                                                            <td style={{ width: '34%' }}>
                                                                                <p><strong> {pass?.title} {pass?.firstName} {pass?.lastName} </strong></p>
                                                                            </td>
                                                                            <td style={{ width: '33%' }}>
                                                                                <p>{pass?.email || '-'}</p>
                                                                            </td>
                                                                            <td style={{ width: '33%' }}>
                                                                                <p>{pass?.phoneno || '-'}</p>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    })
                                    :
                                    hotelBookingData?.bookingDetails?.[0]?.roomDetailsModel?.map((room:any, roomIndex:any) => {
                                        return (
                                            <div key={`${room?.roomId}${roomIndex}`}>

                                                {/* Room Information */}
                                                <div className="mb-3">
                                                    <h5>Room Information</h5>
                                                    <table className="bookingStatusTable roomInfo" style={{ wordBreak: 'break-all' }}>
                                                        <thead>
                                                            <tr>
                                                                <th>Number of Rooms</th>
                                                                <th>Rooms Type</th>
                                                                <th>Guests</th>
                                                                <th>Rate Plan</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <p><strong>1 Room</strong></p>
                                                                </td>
                                                                <td>
                                                                    <p><strong>{room?.roomType}</strong></p>
                                                                </td>
                                                                <td>
                                                                    <p><strong>
                                                                        {/* {room?.adultCount > 1 ? 'Adults' : 'Adult'} - {room?.adultCount}, {room?.childCount > 1 ? 'Children' : 'Child'} - {room?.childCount} */}
                                                                        {room?.adults > 1 ? 'Adults' : 'Adult'} - {room?.adults}, {room?.children > 1 ? 'Children' : 'Child'} - {room?.children}
                                                                    </strong></p>
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                {/* Guest Information */}
                                                <div className="mb-3">

                                                    <h5>Guest Information</h5>
                                                    <table className="bookingStatusTable" style={{ wordBreak: 'break-all' }}>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '34%' }}>Name</th>
                                                                <th style={{ width: '33%' }}>Email</th>
                                                                <th style={{ width: '33%' }}>Phone</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                hotelBookingData?.bookingDetails?.[0]?.guestInformationModel?.map((pass:any, passIndex:any) => {
                                                                    if (passIndex === roomIndex) {
                                                                        return (
                                                                            <tr key={`${passIndex}`} >
                                                                                <td style={{ width: '34%' }}>
                                                                                    <p><strong> {pass?.title} {pass?.name} </strong></p>
                                                                                </td>
                                                                                <td style={{ width: '33%' }}>
                                                                                    <p>{pass?.email || '-'}</p>
                                                                                </td>
                                                                                <td style={{ width: '33%' }}>
                                                                                    <p>{pass?.phoneno || '-'}</p>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )
                                    })
                            }

                            {/* Total Price Breakup */}
                            <div className="mb-4">
                                <h5 className="mb-2">Total Price Breakup</h5>
                                <div className="hotel-price">
                                    <table className="hotelPriceTable">
                                        <tbody>
                                            <tr>
                                                <td> {roomWithNight?.room}&nbsp;Room&nbsp;<span>x</span>&nbsp;{roomWithNight?.night}&nbsp;Night </td>
                                                <td>₹ {hotelBookingData?.bookingDetails?.[0]?.priceWithMarkup || 0}</td>
                                            </tr>
                                            <tr>
                                                <td>Taxes and Surcharges <span>+</span> </td>
                                                <td>₹ {hotelBookingData?.bookingDetails?.[0]?.totalTax || 0}</td>
                                            </tr>
                                            {
                                                hotelBookingData?.bookingDetails?.[0]?.convenienceFee > 0 &&
                                                <tr>
                                                    <td>Convinience fees charged <span>+</span></td>
                                                    <td>₹ {hotelBookingData?.bookingDetails?.[0]?.convenienceFee}</td>
                                                </tr>
                                            }
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th scope="row">Grand Total</th>
                                                <td><strong>₹ {numberWithCommas(hotelBookingData?.bookingDetails?.[0]?.finalValue || 0)}</strong></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>

                        {/* Policies */}
                        {
                            hotelBookingData?.Messages?.[0]?.ResponseType !== 3 && hotelBookingData?.hotelDetails?.getBookingDetailResult?.rooms &&
                            <div className="mb-4">
                                <h5 className="mb-2">Policies</h5>
                                <div className="policy">
                                    <h5>Cancellation Policy</h5>
                                    {
                                        hotelBookingData?.hotelDetails?.getBookingDetailResult?.rooms?.map((policy:any, policyindex:any) => {
                                            return (
                                                <div key={`${policy?.roomIndex}${policyindex}policy`} className="details">
                                                    {policy?.cancellationPolicy}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <Modal
                show={isCancelModel}
                onHide={() => closeCancelModal()}
                dialogClassName="modal-90w"
                size="xl"
                // backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <div className="modal-header py-2 border-0 row mx-0 mt-2 d-flex justify-content-between">
                    <div className="col-auto ps-0">
                        <h5>Cancellation</h5>
                    </div>
                    <div className="col-auto ps-0">
                        <button type="button"
                            id="closemodal"
                            className="btn-close closebtn_popup_position_gallery"
                            onClick={() => closeCancelModal()}>
                        </button>
                    </div>
                </div>
                <div className="modal-body mb-2">
                    <HotelCancellation
                        cancelModelData={cancelModelData}
                        setIsCancelModel={setIsCancelModel}
                        setCancellationMessage={setCancellationMessage}
                        setShowCancelMessageModel={setShowCancelMessageModel}
                    />
                </div>
            </Modal>

            {/* On Hold Cancellation Modal */}
            {
                hotelBookingData?.Messages?.[0]?.ResponseType === 3 &&
                <OnHoldCancellation
                    holdCancelModal={holdCancelModal}
                    setHoldCancelModal={setHoldCancelModal}
                    tboBookingId={hotelBookingData?.hotelDetails?.getBookingDetailResult?.bookingId}
                    setCancellationMessage={setCancellationMessage}
                    setShowCancelMessageModel={setShowCancelMessageModel}
                />
            }
            {/* On Hold Cancellation Modal */}

            {
                showCancelMessageModel && cancellationMessage &&
                <HotelCancellationMessage
                    message={cancellationMessage}
                    showCancelMessageModel={showCancelMessageModel}
                    setShowCancelMessageModel={setShowCancelMessageModel}
                />
            }
        </div>
    )
}

export default HotelBookingConfirmation
